import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './tos.module.scss';
import { isMobile } from 'react-device-detect';
import NavMobile from '../../Nav/NavMobile';
import NavDesktop from '../../Nav/NavDesktop';

const TermsAndConditions = () => {
    const { t } = useTranslation();
    return (
        <Box className={styles.tosWrapper}>
            {isMobile ? <NavMobile /> : <NavDesktop />}
            <Box className={styles.termsAndConditions}>
                <Typography
                    textAlign={'center'}
                    fontFamily={'InstrumentSans-bold'}
                    fontSize={isMobile ? '30px' : '40px'}>
                    Terms and Conditions incl. GDPR
                </Typography>
                <Typography>Fanti Systems AB (Plinks TV)</Typography>
                <Typography>Org. No: 559302-7567</Typography>
                <Typography>VAT SE559302756701</Typography>
                <Typography fontFamily={'InstrumentSans-bold'}>General</Typography>
                <Typography>
                    These Terms and Conditions applies to business relationships between Plinks AB,
                    Malmö, Sweden, (hereinafter referred to as “Plinks ”) and the Customer. The
                    Customer are businesses or consumers. These Terms and Conditions applies equally
                    to consumers and businesses (jointly referred to as “Customer”).
                </Typography>
                <Typography>
                    These terms and conditions are subject to Swedish and EU law and in the event of
                    any conflict between them, the laws take precedence.
                </Typography>
                <Typography>
                    The Customer is obliged to keep login name and password secure together with any
                    other user credentials. This includes not to share this information with any
                    other third parties.
                </Typography>
                <Typography>
                    Plinks reserves the right to deny the use of its services by Customers that are
                    under 18-years of age.
                </Typography>
                <Typography>
                    These terms and conditions may be subject to change due to changed legislation
                    or for any other business-related reason that Plinks sees fit.
                </Typography>
                <Typography>
                    No statement or condition of sale contained within these terms affects or
                    restricts the statutory rights as defined under the EU Consumer Rights
                    Directive, and we always operate in accordance with the EU Digital Services Act,
                    as well as all other relevant and regulations.
                </Typography>
                <Typography fontFamily={'InstrumentSans-bold'}>Services</Typography>
                <Typography>
                    Plinks AB is a provider of digital services. The core business is to enable
                    transference of streaming media between a producer of content to a consumer.
                    Plinks is responsible for the fulfilment of the service but is in no way
                    responsible for the content that is streamed.
                </Typography>
                <Typography fontFamily={'InstrumentSans-bold'}>Restrictions</Typography>
                <Typography>
                    Plinks respects your rights and expects that you respect those of Plinks. You
                    agree not to use the Services to commit or promote, enable or facilitate
                    unlawful or criminal acts or violations of these Terms and Conditions or
                    facilitate or promote others to do so. Restricted content is e.g:
                </Typography>
                <Typography>- child pornography;</Typography>
                <Typography>- discriminating,</Typography>
                <Typography>- threatening,</Typography>
                <Typography>- abusive</Typography>
                <Typography>- unlawful; </Typography>
                <Typography>- racist</Typography>
                <Typography>- violent</Typography>
                <Typography>- hateful and/or</Typography>
                <Typography>- deceptive.</Typography>
                <Typography>
                    Furthermore, content that you don’t have the right to transfer is restricted.
                    Content that violates or misappropriates intellectual property rights, privacy
                    rights, including data protection rights and any rights that are protected by
                    current legislation, is restricted. In addition, content that infringes on or
                    violates any applicable law or regulation is restricted.
                </Typography>
                <Typography>
                    Plinks reserves the right to automatically machine-scan the content and
                    immediately shut down the customers’ accounts, and will report the Cto
                    appropriate authorities, if the above restrictions are not met.
                </Typography>
                <Typography fontFamily={'InstrumentSans-bold'}>
                    Intellectual Property Rights
                </Typography>
                <Typography>
                    The use of Plinks will not in any way restrict the Intellectual Property Rights
                    of the producer of the material. This applies also to the relationship between
                    the producer and the Consumer. If the Producer wishes to grant a permission to
                    use the material completely or partly to the Consumer, in connections to third
                    parties to the Consumer, this should be stated in a clear and written consent.
                </Typography>
                <Typography fontFamily={'InstrumentSans-bold'}>Privacy Policy/GDPR</Typography>
                <Typography>
                    We will always process your data in line with the principles under the EU’s
                    General Data Protection Regulation (GDPR) and you can opt out at any time.
                </Typography>
                <Typography>
                    As a new customer on the Plinks website you may sign up for exclusive offers and
                    discounts by email. By providing your consent Plinks will send to your
                    registered email address our regular sales newsletter and special offers,
                    discounts and competitions. You can always opt out later by either: logging into
                    your account and changing your communication preferences, clicking on the
                    “unsubscribe” link on the bottom of our emails, or contacting our customer
                    service department.{' '}
                </Typography>
                <Typography>
                    Plinks will never sell your data to any third party. But we may disclose your
                    personal information to third parties when permitted by law including, inter
                    alia:
                </Typography>
                <Typography>(a) with your explicit consent.</Typography>
                <Typography>
                    (b) to our suppliers, in order for them to help us provide our services to you,
                    this includes:
                </Typography>
                <ul>
                    <li>
                        Our provider of customer relationship management services (which allows us,
                        for example, to send personalised email communications to you)
                    </li>
                    <li>Our provider of file storage and management services.</li>
                    <li>Our payment services provider to process your payment.</li>
                </ul>
                <Typography fontFamily={'InstrumentSans-bold'}>Prices</Typography>
                <Typography>
                    Prices are including VAT, if nothing other is clearly stated. Depending on the
                    tax rules of the Customer’s country, VAT may be added or be payable at the
                    Customer’s local customs office. Within Europe VAT, for each country, is
                    calculated automatically.
                </Typography>
                <Typography>
                    There are three levels you can choose from and the prices are linked to the
                    degree access.These levels are:
                </Typography>
                <ul>
                    <li>Free</li>
                    <li>Premium</li>
                    <li>Premium Plus</li>
                </ul>
                <Typography fontFamily={'InstrumentSans-bold'}>Registration</Typography>
                <Typography>
                    Registration by the user is required. It is necessary to be able to use the
                    service and to load up material and use. To be able to receive remuneration the
                    registration must include IBAN-number a phone number.
                </Typography>
                <Typography fontFamily={'InstrumentSans-bold'}>Contract</Typography>
                <Typography>
                    To be able to use Plinks’s services a legally binding contract must be
                    established. These Terms and Conditions together with agreed upon prices
                    constitute a contract, after a by Plink approved registration. The contractual
                    language is English.
                </Typography>
                <Typography fontFamily={'InstrumentSans-bold'}>Right of withdrawal</Typography>
                <Typography>
                    A consumer shall be entitled to withdraw from the Contract within fourteen (14)
                    days without giving a reason for doing so. A prerequisite is that the service
                    has not been activated by the content producer.
                </Typography>
                <Typography>
                    To exercise the right of withdrawal, the Customer must notify Plinks of the
                    decision to withdraw from the contract in a clear declaration (e.g. by sending
                    an email).
                </Typography>
                <Typography>
                    The withdrawal deadline shall be deemed to be met if the Customer sends the
                    communication concerning the exercise of the right of withdrawal before the
                    expiry of the deadline.
                </Typography>
                <Typography>
                    The right of withdrawal shall not apply to custom built and/or designed services
                    according to Customer’s specifications.
                </Typography>
                <Typography fontFamily={'InstrumentSans-bold'}>
                    Consequences of withdrawal
                </Typography>
                <Typography>
                    If the Customer wishes to withdraw from a contract, Plinks will reimburse
                    payments received from the Customer. Plinks will use the same payment method as
                    the Customer used for the original transaction to provide the reimbursement,
                    unless otherwise expressly agreed upon. Warranty formalities shall be carried
                    out in congruence with the legal regulations.
                </Typography>
                <Typography fontFamily={'InstrumentSans-bold'}>
                    Due date and payment terms
                </Typography>
                <Typography>
                    Unless otherwise agreed in writing, invoices from Plinks must be paid in full
                    without delay. Orders paid in advance will be shipped upon receipt of payment.
                    For payments by credit card, the actual sum shall be debited when the invoice is
                    issued. The total amount shall be reserved on the Customer’s credit card as soon
                    as the online order is submitted.
                </Typography>
                <Typography>
                    Plinks reserves the right to decline cheques and other non-cash means of
                    payment. Foreign currency payments shall be credited according to our bank
                    statement. Any bank fees must be borne by the Customer.
                </Typography>
                <Typography>
                    If the Customer falls into default on the payment of the purchase price, late
                    payment interest is to be paid on the total purchase in accordance with
                    applicable laws. If Plinks is able to prove that greater damages were suffered
                    as a result of the default, Plinks shall be entitled to assert the corresponding
                    claims on these grounds.
                </Typography>
                <Typography fontFamily={'InstrumentSans-bold'}>
                    Place of fulfilment and jurisdiction
                </Typography>
                <Typography>
                    The laws of Sweden shall apply together with applicable European Union laws. The
                    place of fulfilment for all services and products arising from business
                    transactions with Plinks shall be at the place of business of Plinks in Malmö,
                    Sweden.
                </Typography>
                <Typography>
                    These terms and conditions as well as all disputes or claims arising hereof
                    shall be governed and construed by the laws of Sweden together with applicable
                    European Union laws and settled within the Swedish general court system.
                </Typography>
                <Typography>
                    If any of these provisions cannot be applied for whatever reason, this shall not
                    affect the validity of the remaining provisions.
                </Typography>
                <Typography fontFamily={'InstrumentSans-bold'}>Liability</Typography>
                <Typography>
                    Plinks is not liable for loss of business or income under any circumstances.
                </Typography>
                <Typography>
                    Plinks will keep the details of the Customer’s order and payment secure, in the
                    absence of negligence on the Plinks’s part, Plinks cannot be held liable for any
                    loss the Customer may suffer if a third party procures unauthorised access to
                    any data the Customer provides when accessing or ordering from Plinks’s
                    Websites.
                </Typography>
                <Typography>
                    Plinks is not responsible or liable for the accuracy of the information provided
                    to Plinks by third parties and is not responsible for any third party&apos;s
                    policies or practices.
                </Typography>
                <Typography>
                    Plinks is not liable for any non-intended consequences that might occur if the
                    Customer is in breach with these Terms and Conditions.{' '}
                </Typography>
                <Typography>
                    Plinks may suspend or cancel payment or refuse a refund request if we find
                    evidence of fraud, abuse, or unlawful or other manipulative behaviour that
                    entitles Plinks to a corresponding counterclaim.
                </Typography>
            </Box>
        </Box>
    );
};

export default TermsAndConditions;
